import React, { useState } from "react";
import { PiCoinsLight } from "react-icons/pi";
import { AppConfig } from "@/utils/AppConfig";
import { useTranslation } from "react-i18next";
import { formatMoneyForInput } from "@/utils/helpers";

interface ProductCostInputProps {
  // min?: number;
  // max?: number;
  // step?: number;
  value: number | string;
  onChange: (value: number) => void;
  place?: "card" | "modal";
}

const ProductCostInput: React.FC<ProductCostInputProps> = ({
  // min = 0,
  // max = 999999,
  value,
  onChange,
  place = "modal",
}) => {
  const { t } = useTranslation();
    const [isFoucused, setIsFocused] = useState(false);
  

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    // Disable esLint Because we need that Behavior of make a placeholder
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    onChange(newValue);
  };

  return (
    <div
      className={`relative flex h-12 w-full items-center justify-center overflow-hidden ${place === "card" ? "rounded-md" : "rounded-sm"} border border-gray-200 ${place === "card" ? "md:h-9" : "md:h-12"}`}
    >
      <PiCoinsLight
        size={20}
        className="absolute start-2 top-1/2 -translate-y-1/2 text-gray-400"
      />
      <input
        type="number"
        name="productCost"
        id="productCost"
        placeholder={t("productCostInput.productCost") as string}
        value={isFoucused ? value : formatMoneyForInput(value) }
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onChange={handleInputChange}
        className="h-full w-full border-none pe-12 ps-10 outline-none"
        // min={min}
        // max={max}
        step={0.01}
      />
      <span className="absolute end-2 top-1/2 -translate-y-1/2 border-s ps-3 text-gray-500">
        {AppConfig.currency.icon()}
      </span>
    </div>
  );
};

export default ProductCostInput;
